/**
 * SourceGenerator Status Chip Component
 * Displays source generator status with appropriate color
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip } from '@mui/material';
import {
  SourceGeneratorStatus,
  STATUS_LABELS,
  STATUS_COLORS,
} from '../../../types/sourceGenerator';

interface SourceGeneratorStatusChipProps {
  status: SourceGeneratorStatus;
  size?: 'small' | 'medium';
}

export const SourceGeneratorStatusChip: React.FC<SourceGeneratorStatusChipProps> = ({
  status,
  size = 'small',
}) => {
  return (
    <Chip
      label={STATUS_LABELS[status] || status}
      size={size}
      color={STATUS_COLORS[status] || 'default'}
    />
  );
};

export default SourceGeneratorStatusChip;
